import { useEffect, useState } from "react";
import pick from 'ramda/src/pick';

import { useNetwork } from "../../hooks/useNetwork";

// import { MATCH_DATES_STATUS } from "./types";

const getStatus = (statuses: string[]) => {
  if(statuses.indexOf("MATCHING")!== -1) return "MATCHING";
  if(statuses.indexOf("ACTIVE")!== -1) return "ACTIVE";
  if(statuses.indexOf("UPCOMING")!== -1) return "UPCOMING";
  if(statuses.indexOf("CLOSED")!== -1) return "CLOSED";
  
  return "ARCHIVED";
};

export const useMatchDatesStatus = () => {
  const [status, setStatus] = useState<string>();
  const { selectedNetwork, getL2Options } = useNetwork();

  useEffect(() => {
    if (!selectedNetwork.l1Id) return;

    const l2s = getL2Options(selectedNetwork.l1Id);
    const statuses = l2s.map(pick(["matchingRoundStatus"]))
      .map((obj: any) => obj.matchingRoundStatus)
      .filter((item, i, ar) => ar.indexOf(item) === i);
    setStatus(getStatus(statuses));

  }, [selectedNetwork, getL2Options]);

  return { status };
  
};